// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.carousel-view-area {
    width: 100%;
    overflow-x: hidden;
}

.pagination-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.carousel {
    display: flex;
    width: 300%;
    justify-content: space-around;
    overflow-x: hidden;
    flex-direction: row;
}

.carousel-item {
    user-select: none;
    width: 100%;
}

.dot {
    width: 1.2rem;
    height: 1.2rem;
    fill: gray;
    margin: 0 -3px;
}

.dot-synced {
    fill: gray;
}

.dot-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.pagination-arrow {
    padding: 10px;
    fill: gray;
}

.pagination-arrow-container {
    display: contents;
}

.pagination-arrow.pagination-arrow-disabled {
    fill: lightgray;
}

.all-clues-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-clue-container {
    width: 100%;
}

.all-clues-modal .carousel-item:nth-child(2){
    font-weight: 600;
}

.shuffle-icon-container {
    display: contents;
}

.shuffle-icon {
    fill: gray;
    width: 20px;
    height: auto;
}

.shuffle-icon path {
    stroke-width: 0.6px;
    stroke: gray;
}

.indicator-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
}

.active-clue {
    font-weight: 600;
}

html[data-theme="dark"] .active-clue {
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/Carousel.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".carousel-container {\n    width: 100%;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.carousel-view-area {\n    width: 100%;\n    overflow-x: hidden;\n}\n\n.pagination-container {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.carousel {\n    display: flex;\n    width: 300%;\n    justify-content: space-around;\n    overflow-x: hidden;\n    flex-direction: row;\n}\n\n.carousel-item {\n    user-select: none;\n    width: 100%;\n}\n\n.dot {\n    width: 1.2rem;\n    height: 1.2rem;\n    fill: gray;\n    margin: 0 -3px;\n}\n\n.dot-synced {\n    fill: gray;\n}\n\n.dot-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.pagination-arrow {\n    padding: 10px;\n    fill: gray;\n}\n\n.pagination-arrow-container {\n    display: contents;\n}\n\n.pagination-arrow.pagination-arrow-disabled {\n    fill: lightgray;\n}\n\n.all-clues-modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.modal-clue-container {\n    width: 100%;\n}\n\n.all-clues-modal .carousel-item:nth-child(2){\n    font-weight: 600;\n}\n\n.shuffle-icon-container {\n    display: contents;\n}\n\n.shuffle-icon {\n    fill: gray;\n    width: 20px;\n    height: auto;\n}\n\n.shuffle-icon path {\n    stroke-width: 0.6px;\n    stroke: gray;\n}\n\n.indicator-container {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n    align-items: center;\n    justify-content: center;\n}\n\n.active-clue {\n    font-weight: 600;\n}\n\nhtml[data-theme=\"dark\"] .active-clue {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
